import { makeDeleteRequest } from 'owa-ows-gateway';
import { baseUrl } from '../config';

const deleteContact = (contactId: string): Promise<Response> => {
    return makeDeleteRequest(`${baseUrl}('${contactId}')`, undefined, undefined, true, null);
};

export default deleteContact;
